import { render, staticRenderFns } from "./system-menu-management.vue?vue&type=template&id=27c9ed24&"
import script from "./system-menu-management.vue?vue&type=script&lang=js&"
export * from "./system-menu-management.vue?vue&type=script&lang=js&"
import style0 from "./system-menu-management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports